module.exports = __webpack_public_path__ + "assets/cc1a2c619e4443d726748c95179e36da.png";